const routes = [
  {
    path: "tools",
    redirect: "tools/map_debug",
    component: () => import("@/views/Tools/MainView.vue"),
    name: "tools",
    children: [
      {
        path: "map_debug",
        component: () => import("@/views/Tools/Map.vue"),
        name: "map-debug",
      },
    ],
  },
];

export default routes;
